
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
/**
 * @Description: 处理对应code码对应的动态错误信息
 * @author jing
 * @date 2023/7/13 15:52
 * @params:
 */
import {isJSON, isValueEmpty, setConfigCharacters} from "@/utils/common";

// 处理数组数据问题
function handleArrayData(data) {
  if (Array.isArray(data)) {
    return data.join('、');
  } else {
    return data;
  }
}

export const dynamicErrorCodeFun = (data, value) => {
  if (data) {
    let codeObj = {};
    let code = data.code;
    let message = data.others ? data.others.errorMessage : '';
    let jsonTalg = isJSON(message);
    let text = '';
    if (jsonTalg) {
      let obj = JSON.parse(message);
      let ymsWarehouseName = '';
      let originalYmsWarehouseData = localStorage.getItem('originalYmsWarehouseData') ? JSON.parse(localStorage.getItem('originalYmsWarehouseData')) : [];
      if (originalYmsWarehouseData.length > 0) {
        if (obj.ymsWarehouseId) {
          ymsWarehouseName = originalYmsWarehouseData.find(item => item.ymsWarehouseId === obj.ymsWarehouseId).name;
        }
      }
      if (obj.ymsSpus) {
        codeObj['112812'] = `${obj.ymsSpus.join('、')}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002120')}${ymsWarehouseName}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002121')}`;
      }
      if (!isValueEmpty(obj.message)) {
        codeObj['1112810'] = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002122')}${obj.message}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002123')}`;
      }
      for (let key in codeObj) {
        if (Number(key) === code) {
          text = codeObj[key];
        }
      }
    } else {
      codeObj = {
        220029: `SKU: ${message} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002124')}`,
        220031: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002125')}${message} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002126')}`,
        220032: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002127')} ${message} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002128')}`,
        1112765: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002129')} ${message}`,
        1112772: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002130')} ${message}`,
        1112777: `${message}`,
        1112778: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002131')} ${message} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002132')}`,
        111294: `${message} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002133')}`,
        111297: `${message}`,
        1112759: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002134')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002135')} ${message}`,
        1112764: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002136')} ${message}`,
        1112803: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002137')}${message}`,
        111190: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002138')}${handleArrayData(message)}`,
        112834: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002139')}${message} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002140')}`,
        1112739: `${message}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002141')}`,
        122008: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002142')}${message}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002143')}`,
        1112760: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002144')}${message}`,
        1112781:`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002145')}${message}`
      };
      for (let key in codeObj) {
        if (Number(key) === code) {
          text = codeObj[key];
        }
      }
    }
    return text;
  }
};